import styled from '@emotion/styled'

const AspectRatios = {
	'16by9': 9 / 16,
	'21by9': 9 / 21,
	'4by3': 3 / 4,
	'1by1': 1 / 1,
	'9by16': 16 / 9,
	'4by5': 5 / 4,
	'1by2': 2 / 1
} as const

export type AspectRatio = keyof typeof AspectRatios

interface Props {
	aspectRatio?: AspectRatio | number
}

function getTopPadding(aspectRatio: AspectRatio | number) {
	return (typeof aspectRatio === 'number' ? aspectRatio : AspectRatios[aspectRatio]) * 100
}

// Calculate padding based on aspect ratio.
const ResponsiveEmbed = styled.div<Props>`
	position: relative;
	overflow: hidden;

	&:before {
		padding-top: ${({ aspectRatio }) => `${getTopPadding(aspectRatio!)}%`};
		display: block;
		content: '';
	}

	> * {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		border: 0;
	}
`

ResponsiveEmbed.defaultProps = {
	aspectRatio: '16by9'
}

export default ResponsiveEmbed
